// test35
(35 && 0);
